import { render, staticRenderFns } from "./resultCompany.vue?vue&type=template&id=381a79f6&scoped=true&"
import script from "./resultCompany.vue?vue&type=script&lang=js&"
export * from "./resultCompany.vue?vue&type=script&lang=js&"
import style0 from "./resultCompany.vue?vue&type=style&index=0&id=381a79f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a79f6",
  null
  
)

export default component.exports